import { render, staticRenderFns } from "./how-we-do.vue?vue&type=template&id=7dc9136a"
import script from "./how-we-do.vue?vue&type=script&lang=js"
export * from "./how-we-do.vue?vue&type=script&lang=js"
import style0 from "./how-we-do.vue?vue&type=style&index=0&id=7dc9136a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports